<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-card class="box">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Monthly Attendance Report</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-row justify="center" dense>
        <v-col sm="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
            :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined @change="getStd()"
            @click="putnull" persistent-hint hint="Please Select Academic Year " />
        </v-col>

        <v-col sm="2" v-if="std_div_list != null">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
            :items="std_div_list" item-text="std" label="Standard" outlined @change="getDiv" @click="putnull"
            persistent-hint hint="Please Select Standard " />
        </v-col>
        <v-col sm="2" v-if="div_list != null">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="div" return-object :items="div_list"
            item-text="div_name" label="Division" outlined @click="putnull" persistent-hint
            hint="Please Select Division" />
        </v-col>
        <v-col cols="2" v-if="div_list != null">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="year" :items="year_list" item-text="name"
            item-value="name" label="Select Year" outlined persistent-hint hint="Please Select Year" />
        </v-col>
        <v-col cols="2" v-if="div_list != null">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="month" :items="month_list" item-text="name"
            item-value="id" label="Select Month" outlined persistent-hint hint="Please Select Month" multiple />
        </v-col>
        <v-col cols="12" sm="2" md="2" v-if="div_list != null">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="stud_status" :items="status_list"
            item-text="name" return-object label="Status" outlined persistent-hint hint="Select Status" />
        </v-col>
        <v-col sm="2" v-if="sel_ay_data && sel_std_data && div && month && year">
          <v-btn class="mt-6 button" @click="getMonthlyAttendanceData()" :loading="fetch_loader">Fetch</v-btn>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="box" v-if="month_attendance != ''">
      <v-col sm="2">
        <v-btn rounded color="success" outlined @click="fnExcelReport('my-table-id', 'MonthlyAttendendanceReport')"
          :loading="loader"><v-icon color="success">mdi-export</v-icon>Export</v-btn>
      </v-col>
      <div id="my-table-id">
        <div class="scroll">
          <v-simple-table dense class="elevation-1" fixed-header height="500px">
            <thead>
              <tr>
                <th class="">Sr. No.</th>
                <th class="">Registration No.</th>
                <th class="" style="text-align: center;">Name</th>
                <th class="">Standard</th>
                <th class="">Division</th>
                <th class="">Admission Year</th>
                <th class="">Total Working Days (AP)</th>
                <th class="">Total Working Days Of Student</th>
                <th class="">Total Present</th>
                <th class="">Total Absent</th>
                <th class="">Total Percentage</th>
              </tr>
            </thead>
            <tbody style="overflow-y: scroll">
              <tr v-for="(s, index1) in month_attendance" :key="s.id">
                <td>{{ index1 + 1 }}</td>
                <td>{{ s.reg_no }}</td>
                <td v-if="org_id=='wws'">
                  <span v-if="s.name_as_on_aadhar_card">
                    {{ s.name_as_on_aadhar_card }}
                  </span>
                  <span v-else>
                    {{ s.name }}
                  </span>
                </td>
                <td v-else>{{ s.name }}</td>
                <td>{{ s.standard }}</td>
                <td>{{ s.division }}</td>
                <td>{{ s.learner_addmission_year }}</td>

                <td v-for="(a, index) in s.attendance" :key="index">
                  {{ a.total_working_days_sem }}
                </td>

                <td v-for="(a, index) in s.attendance" :key="index">
                  {{ a.total_working_stud }}
                </td>
                <td v-for="(a, index) in s.attendance" :key="index">
                  {{ a.present }}
                </td>
                <td v-for="(a, index) in s.attendance" :key="index">
                  {{ a.absent }}
                </td>
                <td v-for="(a, index) in s.attendance" :key="index">
                  {{ a.percentage }}
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>
      </div>
    </v-card>

    <!-- <v-card class="box" v-if="learner_attendance_info.length > 0">
                <v-col cols="12" md="6" sm="6">

                    <v-btn color="success" dark class="exportbtn" outlined rounded>
                        <download-excel class="mar" :data="learner_attendance_info" :fields="table_fields" worksheet="MonthlyAttendanceReport" name="MonthlyAttendanceReport.xls"> <v-icon dark>mdi-file-excel</v-icon> Export </download-excel>
                    </v-btn>
                </v-col>
                <v-data-table :headers="headers" :items="learner_attendance_info">
                    <template v-slot:top>
                        <v-toolbar flat class="toolbar">
                            <v-toolbar-title>Attendance Details</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </template>
                    <template v-slot:[`item.is_present`]="{ item }">
                        <v-avatar color="success" size="30" v-if="item.is_present == true">
                            <span class="white--text headline">P</span>
                        </v-avatar>

                        <v-avatar v-else color="error" size="30">
                            <span class="white--text headline">A</span>
                        </v-avatar>
                    </template>
                </v-data-table>
            </v-card> -->
  </div>
  <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },

  data: () => ({
    loader: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    // extraBreadcrumbItems: [
      

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    title: "",
    description: "",
    headers: [
      { text: "Sr No", value: "srno" },
      // { text: "Date", value: "date" },
      { text: "Learner", value: "learner" },
      { text: "Standard", value: "standard" },
      { text: "Division", value: "division" },
      { text: "Roll No", value: "roll_no" },
      { text: "Total", value: "total" },
      { text: "Present", value: "total_present" },
      { text: "Absent", value: "total_absent" },
      { text: "Percentage", value: "percentage" },
    ],
    table_fields: {
      "Sr No ": "srno",
      Learner: "learner",
      Standard: "standard",
      Division: "division",
      Total: "total",
      Present: "total_present",
      Absent: "total_absent",
      Percentage: "percentage",
    },
    ay_std_div_list: null,
    sel_ay_data: null,
    show_tt: false,
    std_div_list: null,
    sel_std_data: null,
    div_list: null,
    div: null,
    overlay: false,
    fetch_loader: false,
    org_id: null,
    month_attendance: [],
    picker: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    date: new Date().toISOString().substr(0, 7),
    //date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    menu: false,
    modal: false,
    learner_attendance_info: [],
    month: "",
    year: "",
    year_list: [],
    month_list: [
      { name: "January", id: "1", month_number: "1" },
      { name: "February", id: "2", month_number: "2" },
      { name: "March", id: "3", month_number: "3" },
      { name: "April", id: "4", month_number: "4" },
      { name: "May", id: "5", month_number: "5" },
      { name: "June ", id: "6", month_number: "6" },
      { name: "July", id: "7", month_number: "7" },
      { name: "August", id: "8", month_number: "8" },
      { name: "September", id: "9", month_number: "9" },
      { name: "October", id: "10", month_number: "10" },
      { name: "November", id: "11", month_number: "11" },
      { name: "December", id: "12", month_number: "12" },
    ],
    status_list: [],
    stud_status: null,
  }),
  methods: {
    fnExcelReport(id, name) {
      var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
      tab_text =
        tab_text +
        "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
      tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
      tab_text =
        tab_text +
        "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
      tab_text =
        tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
      tab_text = tab_text + "<table border='1px'>";
      var exportTable = $("#" + id).clone();
      exportTable.find("input").each(function (index, elem) {
        $(elem).remove();
      });
      tab_text = tab_text + exportTable.html();
      tab_text = tab_text + "</table></body></html>";
      var fileName =
        name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

      //Save the file
      // var blob = new Blob([tab_text], {
      //   type: "application/vnd.ms-excel;charset=utf-8",
      // });
      // window.saveAs(blob, fileName);
      const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const filename = name + '.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    },
    getMonthlyAttendanceData() {
      const data = {
        month: this.date,
        ay: this.sel_ay_data.ay_id,
        standard: this.sel_std_data.std_id,
        division_offering: this.div,
        months: this.month,
        year: this.year,
        stud_status: this.stud_status.id,
      };
      this.overlay = true;
      axios
        .post("/Academics/getMonthlyAttendanceData", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            // this.learner_attendance_info =
            //  res.data.learner_attendance_monthly_info;
            this.month_attendance = res.data.month_attendance;
            this.overlay = false;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.overlay = false;
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    getStd() {
      this.std_div_list = null;
      this.sel_std_data = null;
      this.div_list = null;
      this.div = null;
      this.std_div_list = this.sel_ay_data.std_list;
    },
    getDiv() {
      this.div_list = ["All"];
      this.div = "All";
      this.div_list = this.sel_std_data.div_list;
      this.div_list.unshift("All");
      this.div = this.div_list[0];
      if (this.div_list.length == 0) {
        alert("No division found!!!");
        this.div_list = null;
      }
    },
    putnull() {
      this.learner = [];
    },
    onLoad() {
      axios
        .post("/commonAPI/get_ay_std_div")
        .then((res) => {
          this.ay_std_div_list = res.data.data;
          this.sel_ay_data = res.data.curr_ay;
          this.status_list = res.data.status_list;
          this.stud_status = this.status_list[0]
          //this.month_list=res.data.month_list
          this.year_list=res.data.year_list
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => { });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("error", msg);
    },
  },
  mounted() {
    this.onLoad();
    this.org_id = localStorage.getItem("EPS-tenant");
  },
  watch: {},
};
</script>
<style scoped>
input[type="date"] {
  width: 30%;
  display: inline-block;
  padding: 0.3rem;
  border: 1px solid gray;
  border-radius: 30px;
  box-sizing: border-box;
  padding-top: none !important;
  margin-top: none !important;
}

.text-color {
  font-weight: bold;
  color: red;
}

.scroll {
  overflow-x: scroll;
}

.text-color {
  font-weight: bold;
  color: red;
  font-size: small;
}

tr,
td,
th {
  border: 1px solid #ccc;
  text-align: center;
  font-size: small;
}

tr,
tbody {
  border-bottom: 1px solid #ccc;
  border: 1px solid #ccc;
  font-size: small;
}

td {
  margin: 0.3rem !important;
  padding: 0.4rem !important;
  font-size: small;
}

@media (min-width: 320px) {

  td,
  th {
    display: table-cell !important;
    font-size: small;
  }

  td+td,
  th+th {
    width: auto;
    font-size: small;
  }
}

v-simple-table {
  white-space: nowrap !important;
  text-align: center;
  font-size: small;
}

.mytable /deep/ thead th {
  background: #0f2027 !important;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right,
      #2c5364,
      #203a43,
      #0f2027) !important;
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right,
      #2c5364,
      #203a43,
      #0f2027) !important;
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
</style>

